import * as React from 'react';
import { CloseIcon } from './CloseButtonIcons';
import { MODAL_CLOSE_BUTTON_TEST_ID } from './Modal.test.consts';
import * as classNames from 'classnames';

const styles = require('./CloseButton.less');

interface CloseIconProps {
  onClick: () => any;
  className?: string;
}

export const CloseButton: React.FC<CloseIconProps> = props => (
  <div
    className={classNames(styles.container, props.className)}
    onClick={props.onClick}
    data-testid={MODAL_CLOSE_BUTTON_TEST_ID}
  >
    <CloseIcon/>
  </div>
);
